import { NgModule } from '@angular/core';

import { RouterModule } from '@angular/router';
import { mapRoutes } from '../../definitions/permissions.constants';

import { TableComponent } from './components/table/table.component';
import { ManagerComponent } from './components/manager/manager.component';
import { ViewComponent } from './components/view/view.component';

@NgModule({
  imports: [RouterModule.forChild(mapRoutes(TableComponent, ManagerComponent, ViewComponent, 'Tier'))],
  exports: [RouterModule]
})
export class TiersRoutingModule {}
